import { render, staticRenderFns } from "./notFound404.vue?vue&type=template&id=3df5a2c0&"
import script from "./notFound404.vue?vue&type=script&lang=js&"
export * from "./notFound404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports